const DEFAULT_ITEMS = [
  "Asthma Care", "Allergy Relief", "Bronchoscopy", "COPD Management", "Respiratory ICU",
  "24×7 Emergency", "Sleep Apnea Care", "TB Treatment", "PFT & FOT Diagnostics", "Vaccination",
];

export default function Marquee({ items = DEFAULT_ITEMS, dark = true }) {
  const row = [...items, ...items];
  return (
    <div
      data-testid="editorial-marquee"
      className={`w-full overflow-hidden py-4 sm:py-5 border-y ${dark ? "bg-navy border-white/10" : "bg-navy-50 border-navy-100"}`}
    >
      <div className="marquee-track">
        {row.map((item, i) => (
          <span
            key={i}
            className={`flex shrink-0 items-center gap-4 px-4 whitespace-nowrap font-heading text-xs sm:gap-6 sm:px-6 sm:text-sm lg:text-base tracking-[0.2em] uppercase ${
              dark ? "text-slate-300" : "text-navy-700"
            }`}
          >
            {item}
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-brand" />
          </span>
        ))}
      </div>
    </div>
  );
}
